import { ThemedFixedButton } from "@/Button";
import { Header } from "@/Header";
import { SequentialAnimation } from "@/SequentialAnimation";
import { SignupContext } from "@/SignupContext";
import { createFileRoute, useRouter } from "@tanstack/react-router";
import { useContext, useMemo } from "react";
import splashImgSrc from "$/logo.svg";

export const Route = createFileRoute("/sign-up/customer-done")({
  component: RouteComponent,
});

function RouteComponent() {
  const { getInfo } = useContext(SignupContext);
  const { history } = useRouter();
  const userInfo = useMemo(() => {
    const info = getInfo();
    return info;
  }, [getInfo]);

  return (
    <div className="flex flex-col flex-auto">
      <Header
        title="유치원 정보 확인"
        className="text-white border-0 bg-yellow"
      />
      <div className="flex flex-col flex-auto bg-yellow">
        <div className="flex flex-col flex-auto gap-4 px-5 pt-10 bg-white rounded-t-3xl">
          <SequentialAnimation>
            <div className="flex flex-col gap-8 items-center py-12">
              {/* 제목 */}
              <div className="text-center">
                <h1 className="mb-2 text-2xl font-bold text-gray-900">
                  안녕하세요!
                </h1>
                <h2 className="text-2xl font-bold text-gray-900">
                  {userInfo?.nickname || "사용자"}님.
                </h2>
              </div>

              {/* 로고 자리 */}
              <div className="flex justify-center items-center w-40 h-40 bg-orange-200 rounded-full">
                {/* 여기에 로고가 들어갈 예정 */}
                <img
                  src={splashImgSrc}
                  alt="visual"
                  className="object-contain m-auto w-52"
                />
              </div>

              {/* 설명 텍스트 */}
              <div className="space-y-2 text-center">
                <p className="text-base text-gray-600">
                  이제 유치원과 미용실 일정창을 확인하고,
                </p>
                <p className="text-base text-gray-600">
                  예약도 바로 시작해보세요
                </p>
              </div>
            </div>
          </SequentialAnimation>
        </div>
      </div>
      <ThemedFixedButton
        onClick={() => history.push("/customer/layout/home")}
        color="primary"
        size="md"
      >
        가입완료
      </ThemedFixedButton>
    </div>
  );
}
